var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0449 0.293368C14.8464 0.0949188 14.5239 0.0949188 14.3255 0.293368L7.9999 6.63135L1.66192 0.293368C1.46347 0.0949188 1.14099 0.0949188 0.942538 0.293368C0.744089 0.491818 0.744089 0.814299 0.942538 1.01275L7.62781 7.69802C7.72703 7.79725 7.85107 7.84686 7.9875 7.84686C8.11153 7.84686 8.24796 7.79725 8.34719 7.69802L15.0325 1.01275C15.2433 0.814299 15.2433 0.491818 15.0449 0.293368Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.b54f89a64a6167e03fb9a18f2ae67ca7.svg";
export { ForwardRef as ReactComponent };